import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusHomeCarousel } from "../../../../../containers/Home/redux/thunks";
import * as LOADERSTYLE from '../../loader/loaderBanner.styles';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';
import { busHomeCarouselSelector } from './../../../../../containers/Home/redux/selectors';
import HomeCarousel from "./HomeCarousel";

const HomeCaroselWrapper = () => {
    const dispatch = useDispatch();
    const { busHomeCarousel } = useSelector(busHomeCarouselSelector);
    const { data = [] } = busHomeCarousel;
    const renderBusHomeCarousel = Boolean(busHomeCarousel && data && data.length);

    useEffect(() => {
        dispatch(fetchBusHomeCarousel());
        return () => { };
    }, []);

    return (<>
        {renderBusHomeCarousel ?
            <HomeCarousel data={data} />
            : <LOADERSTYLE.Loader>
                <LOADERSTYLE.HomeCarousel>
                    <LineLoader width="100%" height="190px" />
                </LOADERSTYLE.HomeCarousel>
            </LOADERSTYLE.Loader>}
    </>);
}

export default HomeCaroselWrapper;
